import { render } from "./CountryForm.vue?vue&type=template&id=0645cd72"
import script from "./CountryForm.vue?vue&type=script&lang=js"
export * from "./CountryForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__